export default function enableCacheReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'ENABLE_CACHE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'ENABLE_CACHE_ERROR':
            return {...state, ...{error: action.error}};

        case 'ENABLE_CACHE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}